module.exports = __webpack_public_path__ + "static/img/Gacha08.5df3526.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/gasha/Gacha08.png
// module id = 8Btz
// module chunks = 1